<template>
  <transition-group name="list" tag="div">
    <ExerciseCard v-for="exercise in exercises" :key="exercise.objectID" :exercise="exercise" class="mt-12" />
  </transition-group>
</template>

<script>
import ExerciseCard from '@/components/exercises/ExerciseCard';

export default defineNuxtComponent({
  components: {
    ExerciseCard,
  },
  props: {
    exercises: {
      type: Array,
      required: true,
    },
  },
});
</script>

<style>
@reference "~/assets/css/main.css";
.list-enter-active,
.list-leave-active {
  @apply transition-all delay-500;
}
.list-enter,
.list-leave-to {
  @apply opacity-0;
}
</style>
